import { useCallback, useEffect, useState } from 'react';
import { getFaqs } from '../services/faqs';

function mapFaq(faq) {
  return {
    id: faq.id,
    question: faq.question,
    answer: (faq.answer || '').trim(),
    position: faq.position ?? 0,
  };
}

export function useFaqs() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFaqs = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getFaqs();
      const list = (res?.data?.faqs || [])
        .map(mapFaq)
        .sort((a, b) => a.position - b.position);
      setFaqs(list);
    } catch (e) {
      const fallback = '';
      setFaqs(fallback);
      setError(fallback.length ? null : e?.message || 'Failed to load FAQs');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFaqs();
  }, [fetchFaqs]);

  return { faqs, loading, error, refetch: fetchFaqs };
}
